import { useMemo } from "react";
import { useViews } from "../../data/queries/viewQueries";
import { useBoardProvider } from "../board/boardContext";
import { useTranslation } from "react-i18next";
import { ViewsContext } from "./viewsContext";
import { IconLoading } from "../../components/Loading/IconLoading";
import Enums from "../../types/enums";

export const ViewsProvider = ({ children }) => {
  const { currentBoardId } = useBoardProvider();
  const { data: allViews, isPending, isSuccess } = useViews(currentBoardId);
  const { t, ready } = useTranslation(["Layout"], {
    useSuspense: false,
  });

  const views = useMemo(
    () => allViews?.filter((view) => !view.IsSystemView) || [],
    [allViews]
  );

  const systemViews = useMemo(() => {
    return (allViews?.filter((view) => view.IsSystemView) || []).map((view) => {
      // Find the enum key (string) from the integer value (view.ViewType)
      const viewTypeKey = Object.keys(Enums.ViewType).find(
        (key) => Enums.ViewType[key] === view?.ViewType
      );

      return {
        ...view,
        Name: t(`Navigation.${viewTypeKey}`),
      };
    });
  }, [allViews, t]);

  const favoriteViews = useMemo(() => {
    return (allViews?.filter((view) => view.IsFavorite) || []).map((view) => {
      const viewTypeKey = Object.keys(Enums.ViewType).find(
        (key) => Enums.ViewType[key] === view?.ViewType
      );

      return {
        ...view,
        Name: view.IsSystemView ? t(`Navigation.${viewTypeKey}`) : view.Name,
      };
    });
  }, [allViews, t]);

  if (isPending && !isSuccess) {
    return <IconLoading />;
  }

  if (!ready) return null;

  return (
    <ViewsContext.Provider value={{ views, systemViews, favoriteViews }}>
      {children}
    </ViewsContext.Provider>
  );
};
